import React, { ImgHTMLAttributes, useState } from "react";
import useAsyncEffect from "use-async-effect";
import { backgroundClient } from "@whatslly/commons/background/client";
import { BgCommands } from "@whatslly/commons/bgCommands";
import { dataUriToBase64 } from "@whatslly/commons/utils";
import { dataURItoBlob } from "@whatslly/commons/dataUriUtils";

const cache = new Map<string, string>();

export const AsyncImage: React.FC<ImgHTMLAttributes<HTMLImageElement>> = (props) => {
  const [loadedSrc, setLoadedSrc] = useState<string | undefined | null>(null);
  useAsyncEffect(
    async (isMounted) => {
      if (import.meta.env.VITE_ASYNC_IMAGE_BYPASS === "true") {
        setLoadedSrc(props.src);
        return;
      }
      setLoadedSrc(null);
      if (!props.src) {
        return;
      }
      if (cache.get(props.src)) {
        setLoadedSrc(cache.get(props.src));
        return;
      }
      try {
        const res = await backgroundClient.send<typeof BgCommands.HTTP_REQUEST, string>(BgCommands.HTTP_REQUEST, {
          method: "GET",
          responseType: `base64`,
          fullUrl: props.src,
        });
        if (isMounted()) {
          const { base64, type } = dataUriToBase64(res);
          if (base64 && type) {
            const blobUrl = URL.createObjectURL(dataURItoBlob(base64, type));
            setLoadedSrc(blobUrl);
            cache.set(props.src, blobUrl);
          }
        }
      } catch {
        setLoadedSrc(props.src);
        cache.set(props.src, props.src);
      }
    },
    [props.src]
  );
  if (loadedSrc) {
    return <img {...{ ...props, src: loadedSrc }} />;
  }
  return null;
};
